import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getTeams } from '../../api/documentAPI';

import TeamList from "../../components/teams/TeamList";

import '../../css/pages/manage_teams.css' ;

const ManageTeams = () => {

    const [t] = useTranslation('global');
    const navigate = useNavigate();
    const [teams, setTeams] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchTeams = async () => {
        try {
            const response = await getTeams();
            const teams = response.map((team) => ({
                value: team.Id,
                label: team.Name,
                adDn: (team.AdDn ?? team.adDn ?? '').trim()
            }));
            setTeams(teams);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching teams: ", error);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        setIsLoading(true);
        fetchTeams();
    }, []);

    const handleGoBack = () => {
        navigate('/');
    };

    const handleCreateTeam = () => {
        navigate('/CreateTeam');
    }

    return (
        <div className='page-wrap'>
            <button className="return-button return-button-top" onClick={handleGoBack}>
                <span className="material-symbols-outlined">arrow_back</span>{t('return')}
            </button>
            <div className="header-title">
                    <h1>{t('teams')}</h1>
                    
                    <div className="add-button-container">
                        <button className="add-button" onClick={handleCreateTeam}>
                            <span className="material-symbols-outlined">add</span>
                        </button>
                    </div>
                </div>
                
                <div className={`user-detail-wrapper ${isLoading ? 'center-loader' : ''}`}>
                {isLoading ? (
                <div className="lds-ellipsis">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div> 
                ) : (
                <TeamList 
                    teams={teams} 
                    onTeamChangeEvent={fetchTeams}
                /> )}
            </div>

        </div>
    );
}

export default ManageTeams;